module.exports = __webpack_public_path__ + "media/images/emblems/Lantsch_Lenz_wappen-392abde0227998b4bae0a4476a0db60e.svg";